const HistoricalCongestionModule =   {
    name: "Historical Congestion",
    mapLayerIcon: "",
    defaultOn: false,
    showOnMap: true,
    wmsMapLayer: "cdot:congestionsegments_hist",
    wmsPublish: "tasWebapp.congestion.segments.publishing",
    congestionLayer:true
}

export default HistoricalCongestionModule;
